import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TechnologySection } from './components/TechnologySection';
import { ProblemCardsSection } from './components/ProblemCardsSection';
import { Legacy } from './components/Legacy';
import { PartnersSection } from './components/PartnersSection';
import { CallToActionWeb } from './components/CallToActionWeb';
import { PricingPlansSection } from './components/PricingPlansSection';
import { Footer } from './components/footer';
import { PrivacyPolicy } from './components/pricavyPolicy';
import { TermsNConditions } from "./components/termsConditions";
import EnterprisesPage from './pages/Enterprises';
import CaseStudyPage from './pages/CaseStudy';
import PreviewVisualizations from './pages/PreviewVisualizations';
import Crops from './pages/Crops';
import CropStory from './pages/CropStory';
import Guide from './pages/Guide';
import GuideStory from './pages/GuideStory';
import CropWiki from './pages/CropWiki';
import TryYourField from './pages/TryYourField';
import TryYourFieldExperience from './components/tryfield/TryYourFieldExperience';
import SmoothScroll from 'smooth-scroll';
import { Route, Routes } from 'react-router-dom';


export const scroll = new SmoothScroll('a[href*="#"]', {
	speed: 1000,
	speedAsDuration: true,
});

const App = () => {
	const [lang, setLang] = useState("EN");
	const [dir, setDir] = useState('ltr');
	const toggleLanguage = () => {
	    const nextLang = lang === "EN" ? "AR" : "EN";
    const nextDir = dir === "ltr" ? "rtl" : "ltr";

    setLang(nextLang); // Update state
    setDir(nextDir); // Update direction state
    localStorage.setItem("preferredLanguage", nextLang); // Persist to localStorage
  };

  // Retrieve and apply language and direction on page load
  useEffect(() => {
    const savedLanguage = localStorage.getItem("preferredLanguage") || "EN";
    const savedDirection = savedLanguage === "AR" ? "rtl" : "ltr";

    setLang(savedLanguage);
    setDir(savedDirection);
    updateLanguage(savedLanguage);
  }, []); // Empty dependency array ensures it runs only once
  
  function updateLanguage(lang) {
	// Update UI and content based on the language
	console.log(`Language changed to ${lang}`);
  }

	const theme = 'light';
	useEffect(() => {
		document.documentElement.setAttribute('dir', dir);
		document.documentElement.setAttribute('data-theme', theme);
	}, [dir]);

	return (
		<div className="relative group h-screen" dir={dir}>
      <Routes>
        <Route path="/privacy" element={<PrivacyPolicy lang={lang} toggleLanguage={toggleLanguage} />} />
		<Route path="/terms" element={<TermsNConditions />} />
        <Route path="/enterprises" element={<EnterprisesPage lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/projects/:farmId" element={<CaseStudyPage lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/preview" element={<PreviewVisualizations />} />
        <Route path="/crops" element={<Crops lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/crops/:slug" element={<CropStory lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/guide" element={<Guide lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/guide/:slug" element={<GuideStory lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/wiki" element={<CropWiki lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/wiki/:crop" element={<CropWiki lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/try-your-field" element={<TryYourField lang={lang} toggleLanguage={toggleLanguage} />} />
        <Route path="/platform" element={<MainLayout lang={lang} dir={dir} toggleLanguage={toggleLanguage} />} />
        <Route path="/" element={<EnterprisesPage lang={lang} dir={dir} toggleLanguage={toggleLanguage} />} />
      </Routes>

   
    </div>

		// <div className='relative group h-screen' dir={dir}>
		// 	{/* Background Image as a Pseudo-Element */}
		// 	<div className="fixed inset-0 bg-[url('../public/img/Light/map.png')] bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-0 before:absolute before:inset-0 before:opacity-50"></div>


		// 	{/* Main app content */}
		// 	<div className="relative z-20 ">
		// 		<Navbar lang={lang} toggleLanguage={toggleLanguage} />


		// 		<HeroSection lang={lang} />
		// 		<TechnologySection lang={lang} />
		// 		<ProblemCardsSection lang={lang} />
		// 		{/* <EcosystemSection lang={lang} /> */}
		// 		<Legacy lang={lang} />
		// 		<PartnersSection lang={lang} />
		// 		<CallToActionWeb lang={lang} />
		// 		{/* <CallToActionMobile lang={lang} /> */}
		// 		<PricingPlansSection lang={lang} />
		// 		<Aboutus lang={lang}/>
		// 		{/* <TestimonialsSection /> */}
		// 		{/* 		  <ValueImpactSection lang={lang} />*/}
		// 		<Footer lang={lang} />
		// 	</div>
		// </div>
	);
};
const MainLayout = ({ lang, dir, toggleLanguage }) => (
	<div className="relative group h-screen" dir={dir}>
	  {/* Background Image as a Pseudo-Element */}
	  <div className="fixed inset-0 bg-[url('../public/img/Light/map.png')] bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-0 before:absolute before:inset-0 before:opacity-50"></div>
  
	  {/* Main app content */}
	  <div className="relative z-20">
		<Navbar lang={lang} toggleLanguage={toggleLanguage} />
		<HeroSection lang={lang} />
		<TechnologySection lang={lang} />
		<section id="try-your-field" className="max-w-6xl mx-auto px-4 py-12">
		  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center">
		    {lang === "AR" ? "جرّبها على حقلك" : "Try it on your own field"}
		  </h2>
		  <p className="mt-2 mb-6 text-center text-gray-600 max-w-2xl mx-auto">
		    {lang === "AR"
		      ? "أسقط دبوسًا على أرضك وشاهد الطقس واحتياج المحصول المائي فورًا — دون تسجيل."
		      : "Drop a pin on your land and see the weather and crop water demand instantly — no sign-up."}
		  </p>
		  <TryYourFieldExperience lang={lang} embedded />
		</section>
		<ProblemCardsSection lang={lang} />
		<Legacy lang={lang} />
		<PartnersSection lang={lang} />
		<CallToActionWeb lang={lang} />
		<PricingPlansSection lang={lang} />
		<Footer lang={lang} />
	  </div>
	</div>
  );
export default App;


